import { setTimeout } from "node:timers/promises";

import { Error404 } from "@acme/ui/shared/404";

import { env } from "~/env";

export const loader = async () => {
  if (env.ARTIFICIAL_SLOWDOWN_TIMEOUT_IN_MS) {
    await setTimeout(env.ARTIFICIAL_SLOWDOWN_TIMEOUT_IN_MS);
  }
  return {};
};

export default function SplatRoute() {
  return <Error404 />;
}
